import { combineReducers } from 'redux';
import processReducer from './process';
import activeProcessReducer from './process-active';
import searchReducer from './search';
import adminToolReducer from './admintool';
import sidebarReducer from './sidebar';
import modalReducer from './modal';
import toolsReducer from './tools';
import outputsReducer from './outputs';
import cacheReducer from './cache';
import confirmationDialogReducer from './confirmation-dialog';
import operationReducer from './operation';
import errorReducer from './error';
import pageReducer from './page';
import settingsReducer from './settings';
import propertyFilterReducer from './property-filter';
import authenticationReducer from './authentication';

// Combine Reducers
let reducers = combineReducers({
    processState: processReducer,
    activeProcessState: activeProcessReducer,
    searchState: searchReducer,
    adminToolState: adminToolReducer,
    sidebarState: sidebarReducer,
    modalState: modalReducer,
    toolsState: toolsReducer,
    outputsState: outputsReducer,
    cacheState: cacheReducer,
    confirmationDialogState: confirmationDialogReducer,
    operationState: operationReducer,
    errorState: errorReducer,
    pageState: pageReducer,
    settingsState: settingsReducer,
    propertyFilterState: propertyFilterReducer,
    authenticationState: authenticationReducer
});
export default reducers;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/index.ts